import React from 'react';

import { Box, BoxProps } from '@mui/material';

import { AnnotateOverlay } from './AnnotateOverlay';

const BORDER_WIDTH = 6;

interface IAnnotateContainer extends Omit<BoxProps, 'ref'> {
  isAnnotating?: boolean;
  containerWidth?: number;
  children: React.ReactNode;
}

export const AnnotateContainer: React.FC<IAnnotateContainer> = (props) => {
  const { isAnnotating = false, containerWidth, children, ...others } = props;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} {...others}>
      {isAnnotating && <AnnotateOverlay />}
      <Box
        sx={({ palette: { secondary } }) => ({
          zIndex: 3,
          position: 'relative',
          borderRadius: '14px',
          border: `${BORDER_WIDTH}px solid ${isAnnotating ? secondary.main + '99' : 'transparent'}`,
          //maxWidth: `calc(${containerWidth}px + ${BORDER_WIDTH * 20}px)`,
          maxWidth: `calc(${containerWidth}px + ${BORDER_WIDTH * 36}px)`,
          width: `calc(100% + ${BORDER_WIDTH * 2}px)`,
          margin: `-${BORDER_WIDTH}px`,
        })}
      >
        {children}
      </Box>
    </Box>
  );
};
